export interface CaseListFilterOptions {
   legalTeams: string[];
   fundingPrograms: string[];
   caseStatuses: string[];
   convertedTo?: string[];
}